<template>
  <section class="info-section">
    <h3
      class="section-title"
      :class="{ 'section-title--empty': histories.length === 0 }"
    >
      リスクアセスメント履歴{{ histories.length === 0 ? ' 無し' : '' }}
    </h3>
    <table
      v-if="histories.length > 0"
      class="info-table"
    >
      <thead>
        <tr>
          <th>日時</th>
          <th>合計</th>
          <th>陽性項目</th>
          <th />
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="history in histories"
          :key="history.id"
        >
          <td class="date-cell">
            {{ displayValue(history.assessedAt) }}
          </td>
          <td>
            <div class="total-score-line">
              <span>{{ displayValue(history.totalScore) }}</span>
              <span
                class="result-badge"
                :class="history.positive ? 'result-badge--positive' : 'result-badge--negative'"
              >
                {{ history.resultLabel }}
              </span>
            </div>
            <div>(非該当 {{ displayValue(history.notApplicableCount) }} 不明 {{ displayValue(history.unknownCount) }})</div>
          </td>
          <td class="positive-items-cell">
            <div
              v-if="history.positiveItems.length > 0"
              class="badge-list"
            >
              <v-tooltip
                v-for="item in history.positiveItems"
                :key="item"
                location="top"
                max-width="320"
              >
                <template #activator="{ props: tooltipProps }">
                  <span
                    v-bind="tooltipProps"
                    class="positive-item-badge"
                  >
                    {{ item }}
                  </span>
                </template>
                <span>{{ item }}</span>
              </v-tooltip>
            </div>
            <template v-else>
              -
            </template>
          </td>
          <td>
            <v-btn
              size="small"
              color="#33B5B4"
              prepend-icon="mdi-open-in-new"
              @click="$emit('open', history)"
            >
              閲覧
            </v-btn>
          </td>
        </tr>
      </tbody>
    </table>
  </section>
</template>

<script setup>
defineProps({
  histories: {
    type: Array,
    default: () => [],
  },
});

defineEmits(["open"]);

const displayValue = (value) => {
  if (value === null || value === undefined || value === "") return "-";
  return value;
};
</script>

<style lang="scss" scoped>
.info-section {
  background-color: #fff;
  border: 1px solid #e8e8e8;
  padding: 10px;
  margin-bottom: 10px;
}

.section-title {
  color: #c8384f;
  font-size: clamp(16px, 1vw, 20px);
  line-height: 1.25;
  font-weight: 700;
  margin-bottom: 6px;
}

.section-title--empty {
  color: #888;
}

.info-table {
  width: 100%;
  border-collapse: collapse;
}

.info-table thead {
  background: #efefef;
}

.info-table th,
.info-table td {
  text-align: left;
  border-bottom: 1px solid #e4e4e4;
  padding: 6px;
  font-size: 12px;
  line-height: 1.45;
  color: #333;
  vertical-align: top;
}

.info-table td.date-cell {
  color: #999;
}

.result-badge {
  display: inline-block;
  margin-left: 4px;
  padding: 1px 6px;
  border-radius: 10px;
  font-size: 11px;
  font-weight: 700;
  white-space: nowrap;
}

.total-score-line {
  display: flex;
  align-items: center;
  gap: 4px;
}

.result-badge--positive {
  background: #fdeaea;
  color: #c0392b;
}

.result-badge--negative {
  background: #f2f2f2;
  color: rgba(0, 0, 0, 0.6);
}

.positive-items-cell {
  max-width: 140px;
}

.badge-list {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
}

.positive-item-badge {
  display: inline-block;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  padding: 1px 6px;
  border-radius: 10px;
  font-size: 11px;
  font-weight: 700;
  background: #fdeaea;
  color: #c0392b;
  cursor: default;
}
</style>
